$(document).ready(function () {
  function doAjaxCall(courseId){
    var url = '/admin/courses/' + courseId + '/chapters';
    $.ajax({
      type: 'GET',
      url: url
    });
  }

  $('#first_step_next').click(function(e) {
    e.preventDefault();
    $(this).hide();
    $('#integrations__select-course').toggleClass('hide');
  });

  $('#integration-course-id').change(function() {
    // if level = chapter, we need to fetch the chapters
    if ($('#level').val() === 'chapter') {
      doAjaxCall($('#integration-course-id').val());
    }
    else {
      $('#integrations__select-chapters').addClass('hide');
      $('#submit').removeClass('hide');
    }
  });

  $('#level').change(function() {
    // if value == chapter we need to fetch the chapters
    // otherwise do nothing
    if ($('#level').val() === 'chapter') {
      doAjaxCall($('#integration-course-id').val());
    }
    else {
      $('#integrations__select-chapters').toggleClass('hide');
    }
  });

  $('#track-version-selector').change(function() {
    var url = $('#track-version-selector option:selected').attr('data-url');
    if (window.location.href != url) {
      window.location.href = url;
    }
  });

  $.datepicker.setDefaults({
    dateFormat: 'dd-mm-yy'
  });
});
